import { datadogLogs } from '@datadog/browser-logs'
import { useClientSideTranslation } from 'src/services/i18n'
import { useGetCurrentPlayer } from 'src/store/player'
import AngleLeftIcon from 'src/app/assets/icons/ico-angle-left.svg'
import CogIcon from 'src/app/assets/icons/ico-cog.svg'
import { isAuthenticatedPlayer } from 'src/types/domain/Player'
import { useGameActions, useGetCurrentLanguage } from 'src/store/game'
import { ALLOWED_LANGUAGES, EXCLUDED_LANGUAGES, LANGUAGE_NAMES } from 'src/services/i18n/utils/getI18nSettings'
import { DisplayName } from './DisplayName'

export function SettingsPanel({ onBackClick }: { onBackClick: () => void }) {
  const currentLanguage = useGetCurrentLanguage()
  const { t } = useClientSideTranslation(currentLanguage)
  const player = useGetCurrentPlayer()
  const playerActions = useGameActions()

  const changeLanguage = (lang: string) => {
    datadogLogs.logger.info('switch_language', {
      user_action: {
        type: 'switch_language',
        currentLanguage,
        newLanguage: lang,
        playerId: isAuthenticatedPlayer(player) ? player.id : null
      }
    })

    playerActions.setCurrentLanguage(lang)
  }

  return (
    <div className="settings-panel">
      <div className="panel-header">
        <button className="back" onClick={onBackClick} type="button">
          <span className="icon">
            <AngleLeftIcon />
          </span>
        </button>
        <CogIcon />
        <span>{t('Settings')}</span>
      </div>
      <div className="panel-content">
        <h3>{t('Account')}</h3>
        <DisplayName />

        {!EXCLUDED_LANGUAGES.includes(currentLanguage) && (
          <div className="panel-content_section">
            <label>
              {t('Language')}
              <select
                onChange={(e) => {
                  changeLanguage(e.target.value)
                }}
                value={currentLanguage}
              >
                {ALLOWED_LANGUAGES.map((langCode) => (
                  <option key={langCode} value={langCode}>
                    {LANGUAGE_NAMES[langCode] ? LANGUAGE_NAMES[langCode] : langCode}
                  </option>
                ))}
              </select>
            </label>
          </div>
        )}
      </div>
    </div>
  )
}
